import { FunctionComponent, HTMLAttributes } from 'react'
import cn from 'classnames'

import './styles.scss'
import {
  BreastLeftIcon,
  BreastRightIcon,
  FeedBottleIcon,
  PeeIcon,
  PoopIcon,
  SleepIcon,
} from '../icons'

const iconStylesMap: Record<string, string> = {
  BreastLeftIcon: 'var(--red-primary)',
  BreastRightIcon: 'var(--green-tertiary)',
  FeedBottleIcon: 'var(--yellow-primary)',
  SleepIcon: 'var(--blue-quaternary)',
  PoopIcon: 'var(--brown-primary)',
  PeeIcon: 'var(--yellow-tertiary)',
}

const iconsMap: Record<string, FunctionComponent<any>> = {
  BreastLeftIcon,
  BreastRightIcon,
  FeedBottleIcon,
  SleepIcon,
  PoopIcon,
  PeeIcon,
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  iconName: string
  width?: number
  height?: number
  iconProps?: Record<string, any>
}

export const EventIcon = (props: Props) => {
  const { iconName, width, height, iconProps, className, ...rest } = props
  const Icon = iconsMap[iconName]
  const backgroundColor = iconStylesMap[iconName]

  return (
    <div
      className={cn('event-icon', className)}
      style={{ width, height, backgroundColor }}
      {...rest}
    >
      <Icon {...iconProps} />
    </div>
  )
}
